interface IValues {
	minNoOfGroupMembers: any;
	noOfGroupMembers: any;
	currentPassword: string;
	newPassword: string;
	confirmPassword: string;
}

export const getPasswordCriteria = (password: string) => {
	return {
		isMinLength: password.length >= 8,
		hasUpperCase: /[A-Z]/.test(password),
		hasLowerCase: /[a-z]/.test(password),
		hasNumber: /\d/.test(password),
		hasSpecialChar: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password),
	};
};

const validateProfile = (values: IValues) => {
	const errors: Partial<IValues> = {};
	if (!values.currentPassword) {
		errors.currentPassword = 'Required';
	}
	if (!values.newPassword) {
		errors.newPassword = 'Required';
	} else if (values.newPassword.length < 8) {
		errors.newPassword = 'Minimum 8 character length';
	} else if (
		values.newPassword.length >= 8 &&
		(!/[A-Z]/.test(values.newPassword) ||
			!/\d/.test(values.newPassword) ||
			!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(values.newPassword))
	) {
		errors.newPassword =
			'Atleast 1 letter should be Uppercase and 1 number and 1 special Characters';
	} else if (values.newPassword === values.currentPassword) {
		errors.newPassword = 'New Password should be not equal to Current Password';
	}
	if (!values.confirmPassword) {
		errors.confirmPassword = 'Required';
	} else if (values.confirmPassword !== values.newPassword) {
		errors.confirmPassword = 'New Password and Confirm must be equal';
	}
	return errors;
};

export default validateProfile;
